/* Sondur Travel — comportamento das páginas da família "pagina" (faqs, instructions).
   Substitui o runtime do GemPages (gp-accordion-v7-5.js e gp-lite-html5-embed), que não entra
   no tema: aqui ficam só o acordeão e o vídeo, com a MESMA troca de classe, variável e ícone
   que o runtime fazia — foi assim que a captura da referência veio (item aberto do childListNumber).

   Acordeão: abrir/fechar um item troca
     - o invólucro do item: atributo data-ewc-aberto
     - o cabeçalho: --c = cor ativa (!important)
     - o ícone: sai a classe de hover, entram as duas de cor ativa, --c = cor ativa, o <path> vira o "menos"
     - o texto: sai a classe de hover, entra color inline
     - o corpo: max-height 0px <-> fit-content
   As cores e os dois desenhos do ícone vêm do próprio markup (variáveis do grupo e atributos
   data-ewc-* gravados pelo montador a partir do gp-data), nunca escritos à mão aqui. */
(function () {
  'use strict';

  var CLS_ICONE_HOVER = 'group-hover:[color:var(--icon-expand-hover-color)]';
  var CLS_ICONE_ATIVO = ['gp-text-[var(--icon-expand-active-color)]', '!gp-text-[var(--icon-expand-active-color)]'];
  var CLS_TEXTO_HOVER = 'group-hover:[color:var(--text-hover-color)!important]';

  function varCss(el, nome, padrao) {
    var v = el ? getComputedStyle(el).getPropertyValue(nome).trim() : '';
    return v || padrao;
  }

  function paiComC(el) {
    var p = el && el.parentElement;
    while (p && !(p.style && p.style.getPropertyValue('--c'))) p = p.parentElement;
    return p;
  }

  function pecas(item) {
    return {
      cabecalho: item.querySelector('.gp-accordion-item_header'),
      icone: item.querySelector('.gp-collapsible-icon'),
      texto: item.querySelector('.gp-accordion-text-content'),
      corpo: item.querySelector('.gp-accordion-item_body')
    };
  }

  function aplicar(acc, item, abrir, fechado) {
    var p = pecas(item);
    var grupo = item.closest('.gp-group') || item;
    var corIcone = varCss(grupo, '--icon-expand-active-color', '#242424');
    var corTexto = varCss(grupo, '--text-hover-color', corIcone);
    var svg = p.icone && p.icone.querySelector('svg');
    var caminho = svg && svg.querySelector('path');
    var paiTexto = paiComC(p.texto);

    if (abrir) {
      item.setAttribute('data-ewc-aberto', '1');
      if (p.cabecalho) p.cabecalho.style.setProperty('--c', corIcone, 'important');
      if (p.icone) {
        p.icone.classList.remove(CLS_ICONE_HOVER);
        p.icone.classList.add(CLS_ICONE_ATIVO[0], CLS_ICONE_ATIVO[1]);
        p.icone.style.setProperty('--c', corIcone, 'important');
      }
      if (caminho) caminho.setAttribute('d', acc.getAttribute('data-ewc-d-aberto') || caminho.getAttribute('d'));
      if (svg && acc.getAttribute('data-ewc-id-aberto')) svg.setAttribute('data-id', acc.getAttribute('data-ewc-id-aberto'));
      if (paiTexto) paiTexto.style.setProperty('--c', corTexto);
      if (p.texto) {
        p.texto.classList.remove(CLS_TEXTO_HOVER);
        p.texto.style.color = corTexto;
      }
      if (p.corpo) p.corpo.style.maxHeight = 'fit-content';
    } else {
      item.removeAttribute('data-ewc-aberto');
      if (p.cabecalho) p.cabecalho.style.removeProperty('--c');
      if (p.icone) {
        p.icone.classList.add(CLS_ICONE_HOVER);
        p.icone.classList.remove(CLS_ICONE_ATIVO[0], CLS_ICONE_ATIVO[1]);
        if (fechado.icone) p.icone.style.setProperty('--c', fechado.icone);
        else p.icone.style.removeProperty('--c');
      }
      if (caminho) caminho.setAttribute('d', acc.getAttribute('data-ewc-d-fechado') || caminho.getAttribute('d'));
      if (svg && acc.getAttribute('data-ewc-id-fechado')) svg.setAttribute('data-id', acc.getAttribute('data-ewc-id-fechado'));
      if (paiTexto) {
        if (fechado.texto) paiTexto.style.setProperty('--c', fechado.texto);
        else paiTexto.style.removeProperty('--c');
      }
      if (p.texto) {
        p.texto.classList.add(CLS_TEXTO_HOVER);
        p.texto.style.removeProperty('color');
      }
      if (p.corpo) p.corpo.style.maxHeight = '0px';
    }
  }

  function ligarAcordeao(acc) {
    if (acc.dataset.ewcLigado) return;
    acc.dataset.ewcLigado = '1';
    var itens = [].slice.call(acc.querySelectorAll('.gp-accordion-item'));
    if (!itens.length) return;
    // a cor fechada é a que os itens fechados já trazem no markup (todos iguais)
    var fechado = { icone: '', texto: '' };
    itens.forEach(function (it) {
      if (it.hasAttribute('data-ewc-aberto') || fechado.icone) return;
      var p = pecas(it);
      fechado.icone = (p.icone && p.icone.style.getPropertyValue('--c').trim()) || '';
      var pt = paiComC(p.texto);
      fechado.texto = (pt && pt.style.getPropertyValue('--c').trim()) || '';
    });
    var unico = (acc.getAttribute('data-ewc-modo') || 'multiple') === 'single';
    itens.forEach(function (item) {
      var cab = pecas(item).cabecalho;
      if (!cab) return;
      cab.addEventListener('click', function () {
        var abrindo = !item.hasAttribute('data-ewc-aberto');
        if (abrindo && unico) {
          itens.forEach(function (o) {
            if (o !== item && o.hasAttribute('data-ewc-aberto')) aplicar(acc, o, false, fechado);
          });
        }
        aplicar(acc, item, abrindo, fechado);
      });
    });
  }

  /* Vídeo: o gp-lite-html5-embed do GemPages só trocava o poster pelo <video> no primeiro toque.
     Aqui o <video> já está no DOM (igual à captura); isto só garante o play no clique e
     mantém um vídeo por vez tocando. */
  function ligarVideo(caixa) {
    if (caixa.dataset.ewcLigado) return;
    caixa.dataset.ewcLigado = '1';
    var v = caixa.querySelector('video');
    if (!v) return;
    caixa.addEventListener('click', function (e) {
      if (e.target.closest('video')) return;
      if (v.paused) { v.play().catch(function () {}); } else { v.pause(); }
    });
  }

  function ligar() {
    [].forEach.call(document.querySelectorAll('gp-accordion'), ligarAcordeao);
    [].forEach.call(document.querySelectorAll('gp-lite-html5-embed'), ligarVideo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
})();
